import { render } from "./Sampel.vue?vue&type=template&id=ef2c6868"
import script from "./Sampel.vue?vue&type=script&lang=js"
export * from "./Sampel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__